import React, {Component} from 'react';
import BaseComponent from "../../../../../base/BaseComponent";
import {BigButtonTool} from "../../oneLineToolSpace";
import resourceSystemIcon from "./resourceSystem.png";
import ResourceSelect from "../../../components/resourceSystemModal/resourceSelect";
import {permissionCheck, uuid} from "../../../../../utils";
import {buildInsertPicHtml} from "../pictureTool/pictureTool";
import {buildInsertVideoHtml} from "../videoTool/videoTool";
import {AUDIO_TYPE, PIC_TYPE, VIDEO_TYPE} from "../../../../../constants";
import MedialSelect from "../components/medialSelect";

class ResourceSystemTool extends BaseComponent {
    state = {
        openKey: uuid(),
        newPicType:['jpg','jpeg', 'gif', 'png', 'bmp', 'JPG', 'JPEG', 'GIF', 'PNG', 'BMP'],
    };
    render() {
        return (
            <div >
                 {permissionCheck('right_to_use_zyk')? <BigButtonTool
                     src={resourceSystemIcon} text={"资源库"} height={this.props.height} width={this.props.width}
                     onClick={()=>{
                         this.resourceSelect.showModal()
                     }}
                 />:null}

                <ResourceSelect
                    key={this.state.openKey}
                    ref={(e)=>this.resourceSelect=e}
                    onOk={(checkArray,newPathList)=>{
                        this.insertPictureToContent(checkArray,newPathList);
                    }}
                    onOkCall={(checkArray,newPathList,call)=>{
                        this.insertPictureToContent(checkArray,newPathList,call);
                    }}
                    onCloseCall={()=>{this.setState({openKey:uuid()})}}
                />
            </div>
        );
    }
    //图片和视频插入编辑器
    insertPictureToContent(fileList,newPathList,call){
        let html="";
        fileList && fileList.map(file => {
            if(this.state.newPicType.indexOf(file.suffix) > -1){
                html += buildInsertPicHtml({
                    ...file,
                    url: file.icon,
                    sourceUrl:file.path,
                    width: file.cssWidth ? parseInt(file.cssWidth) : 0
                });
            }else if(VIDEO_TYPE.indexOf(file.suffix) > -1){
                html += buildInsertVideoHtml({
                    ...file,
                    playUrl:file.icon,
                    url:file.path, videoPic:file.icon, originalWith:file.width, originalHeight:file.height,
                    width: file.cssWidth?parseInt(file.cssWidth):0
                });
            }
        });
        let isSuccess = true;
        if(html) {
            isSuccess = this.props.editor.rmtExecCommand("inserthtml", html);
        }
        call&&call(isSuccess)
    }
}

export default ResourceSystemTool;